module.exports = __webpack_public_path__ + "img/signature_thayana.bcf72f27.jpg";